import { CandidateVisaGetters, ICandidateVisa } from '../../../../../../../../core/src'
import { IFormInputData } from '../../../../../../../core/src'

export class VacancyFilterBuilder {
  public candidateVisa?: ICandidateVisa
  /**
   * What else can we do here, given that the query items are also
   * unknown?
   */
  public query?: any
  public visaTypes: IFormInputData[] = []

  build(): Record<number, IFormInputData> {
    let selectedVisaTypesDict: Record<number, IFormInputData> = {}
    if (this.candidateVisa) {
      const candidateVisaTypes = CandidateVisaGetters.getLowermostSelectedVisaType(this.candidateVisa)
      candidateVisaTypes.forEach((e) => {
        const visaType = this.visaTypes.find((item) => item.value === e.id)
        if (visaType) {
          selectedVisaTypesDict[visaType.value] = visaType
        }
      })
    }
    if (this.query.visaType) {
      const visaTypeIds = this.query.visaType.toString().split(',')
      visaTypeIds.forEach((e: string) => {
        const id = parseInt(e)
        const visaType = this.visaTypes.find((item) => item.value === id)
        if (visaType) {
          selectedVisaTypesDict[visaType.value] = visaType
        }
      })
    }
    return selectedVisaTypesDict
  }
}
